module.exports = __webpack_public_path__ + "img/Background.2837ba2b.png";